import React, { Component } from "react";
import MentionListsRow from "./MentionListsRow";
import moment from "moment";
import CircularProgress from "@material-ui/core/CircularProgress";
import db from "../../api/db";

class MentionLists extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      lists: [],
      bodyheight: "auto"
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.searchQuery();
    this.setAutoReload();
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.interval);
  }

  setAutoReload() {
    this.interval = setInterval(() => this.searchQuery(), 60000);
  }

  bodyHeight() {
    const height = this.divElement.clientHeight;
    const listCount = this.state.lists.length;
    if (listCount) {
      const bodyHeight = (height / listCount) * 6;
      this.setState({
        bodyheight: bodyHeight
      });
    }
  }

  searchQuery() {
    this.setState({
      loading: true
    });
    db.query("list", {
      type: this.props.Type,
      date: {
        from: `${moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD")} 00:00:00`,
        to: `${moment()
          .add(365, "days")
          .format("YYYY-MM-DD")} 00:00:00`
      },
      _sort: {
        date: {
          order: "desc"
        }
      }
    })
      .then(response => {
        if (this._isMounted) {
          this.setState({
            lists: response.data.hits,
            loading: false
          });
          this.bodyHeight();
        }
      })
      .catch(err => {
        console.log(err);
        this.setState({
          loading: false
        });
      });
  }

  render() {
    const lists = this.state.lists;
    const bodystyle = {
      maxHeight: this.state.bodyheight
    };

    return (
      <React.Fragment>
        <h3>{this.props.Title}</h3>
        {this.state.loading ? <CircularProgress size={20} /> : null}
        <div className="scrolltable" style={bodystyle}>
          <table className="strict">
            <thead>
              <tr>
                <th>Dato</th>
                <th></th>
                <th>Antall personer</th>
                <th>Status</th>
                <th>Sist varslet</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody ref={divElement => (this.divElement = divElement)}>
              {lists.map((item, i) => (
                <MentionListsRow
                  key={i}
                  List={item}
                  Row={i % 2 ? "odd" : "even"}
                  searchParams={this.props.searchParams}
                  Params={this.props.Params}
                />
              ))}
            </tbody>
          </table>
          <div className="inset" />
        </div>
      </React.Fragment>
    );
  }
}

export default MentionLists;
